import React, { useContext, useEffect, useState } from "react";
import {
  Routes,
  Route,
  Navigate,
  useLocation,
  Outlet,
  useNavigate,
} from "react-router-dom";
import { Context } from "../config/Context/AuthContext";
import { Login } from "../pages/Login";
import { EditPassword } from "../pages/EditPassword";
import { ForgotPassword } from "../pages/ForgotPassword";
import { Dashboard } from "../pages/Dashboard";
import { verificarTokenHandler } from "../services/auth.service";
import api from "../services/api.service";
import { Token, IdUsuario } from "../utils/localStorage.util";
import { connectSocket } from "../utils/webSocket.util.js";
import Loading from "../components/Loading/index.js";

import { ValidacaoCodigoEmail } from "../pages/ValidacaoCodigoEmail";
import Empresas from "../pages/Empresas";

import { CadastroAssociado } from "../pages/CadastroAssociado";

import { CadastroCliente } from "../pages/CadastroCliente";
import { CadastroParceiro } from "../pages/CadastroParceiro";
import { PropostaEmAnalise } from "../pages/PropostaEmAnalise";
import GruposEconomicos from "../pages/GruposEconomicos";
import SelecionarTiposNegocio from "../pages/SelecionarTiposNegocio";
import SelecionarTiposNegocioSimples from "../pages/SelecionarTiposNegocioSimples";
import DashboardDados from "../components/DashboardDados";
import Header from "../components/Header";
import NotFound from "../pages/NotFound";
import CadastrarCnpj from "../pages/CadastrarCnpj";
import { LoginContext } from "../config/Context/LoginContext";
import SugestaoDeServicos from "../pages/SugestaoDeServicos";
import Juridico from "../pages/Juridico";
import Usuarios from "../pages/Usuarios";
import GruposUsuarios from "../pages/GruposUsuarios";
import AcessoNegado from "../pages/AcessoNegado";
import RotaProtegida from "../components/RotaProtegida";
import {
  CHAVES_GERENCIAMENTO_USUARIOS,
  CHAVES_ROTA_APURACOES,
  CHAVES_ROTA_AUTOMACOES,
  CHAVES_ROTA_CONTA_CORRENTE,
  CHAVES_ROTA_EMPRESAS,
  CHAVES_ROTA_FINANCEIRO,
  CHAVES_ROTA_GRUPOS_ACESSO,
  CHAVES_ROTA_PROJETOS_APURACAO,
  CHAVES_ROTA_GRUPOS_ECONOMICOS,
  CHAVES_ROTA_ICMS,
  CHAVES_ROTA_IMPORTACOES,
  CHAVES_ROTA_INSS,
  CHAVES_ROTA_JURIDICO,
  CHAVES_ROTA_PARAMETRIZACOES,
  CHAVES_ROTA_PARCEIROS,
  CHAVES_ROTA_PIS_COFINS,
  CHAVES_ROTA_PROCESSAMENTO,
  CHAVES_ROTA_RELATORIOS,
  CHAVES_ROTA_VINCULOS,
  CHAVES_ROTA_WORKFLOW,
} from "../config/Context/PermissoesContext";
import EditarDadosCandidato from "../pages/EditarDadosCandidato";
import Parametros from "../pages/Parametros";
import VamosVencerJuntos from "../pages/VamosVencerJuntos";
import Vinculos from "../pages/Vinculos";
import CadastroDetalhado from "../components/CadastroDetalhado";
import Relatorios from "../pages/Relatorios";
import Workflow from "../pages/Workflow";
import Solicitacoes from "../pages/Solicitacoes";
import ExtratorRelatorios from "../pages/ExtratorRelatorios";
import ProcessamentoRelatorio from "../pages/ProcessamentoRelatorio";
import Apuracoes from "../pages/Apuracoes";
import ListaProjetosApuracao from "../pages/ProjetosApuracao/Lista";
import ResumoProjetoApuracao from "../pages/ProjetosApuracao/Resumo";
import ApuracaoDetalheDispatcher from "../pages/Apuracoes/DetalheDispatcher";
import ApuracaoDetalheCat42 from "../pages/Apuracoes/DetalheCat42";
import ApuracaoDetalheIcms from "../pages/Apuracoes/DetalheIcms";
import ApuracaoDetalheConta from "../pages/Apuracoes/DetalheConta";
import ApuracaoDetalheLancamentosEsocial from "../pages/Apuracoes/DetalheEsocial/Lancamentos";
import LancamentosCat42 from "../pages/Apuracoes/LancamentosCat42";
import LancamentosIcmsE111 from "../pages/Apuracoes/LancamentosIcmsE111";
import LancamentosNotasFiscais from "../pages/Apuracoes/LancamentosNotasFiscais";
import LancamentosEcd from "../pages/Apuracoes/LancamentosEcd";
import LancamentosEcf from "../pages/Apuracoes/LancamentosEcf";
import LancamentosContribuicoes from "../pages/Apuracoes/LancamentosContribuicoes";
import LancamentosEcredac from "../pages/Apuracoes/LancamentosEcredac";
import ClassificacaoNcm from "../pages/Apuracoes/ClassificacaoNcm";
import Tributarias from "../pages/Tributarias";
import ImportarSpeds from "../pages/ImportarSpeds";
import Importadores from "../pages/Importadores";
import Automacoes from "../pages/Automacoes";
import CondicaoComercial from "../pages/CondicaoComercial";
import ValoresFatura from "../pages/ValoresFatura";
import Faturamento from "../pages/Faturamento";
import PdfUploader from "../pages/AnexoContrato";
import ClicksignWidget from "../pages/ClicksignWidget";
import AguardandoAssinatura from "../pages/AguardandoAssinatura";
import AssinaturaContrato from "../pages/AssinaturaContrato";
import Contratos from "../pages/Contratos";
import CategoriasTributarias from "../pages/CategoriasTributarias";
import AjustesVerbas from "../pages/AjustesVerbas";
import BasesCalculo from "../pages/BasesCalculo";
import FolhaESocial from "../pages/FolhaESocial";
import FolhaManual from "../pages/FolhaManual";
import Impostos from "../pages/Impostos";
import ResumoGeral from "../pages/ResumoGeral";
import VerbasESocial from "../pages/VerbasESocial";
import VerbasManuais from "../pages/VerbasManuais";
import PreviaINSS from "../pages/PreviaINSS";
import CadastroClienteSimples from "../pages/CadastroClienteSimples";
import ProjetosINSS from "../pages/ProjetosINSS";
import PreviaICMS from "../pages/PreviaICMS";
import ProjetosICMS from "../pages/ProjetosICMS";
import PreviaPISCOFINS from "../pages/PreviaPISCOFINS";
import ProjetosPISCOFINS from "../pages/ProjetosPISCOFINS";
import SobDespesas from "../pages/PreviaPISCOFINS/SobDespesas";
// import BaseCredito from "../pages/PreviaPISCOFINS/BaseCredito"; // Comentado - página removida
import BaseLegal from "../pages/PreviaPISCOFINS/BaseLegal";
import ResumoGeralPisCofins from "../pages/PreviaPISCOFINS/ResumoGeral";
import Extrato from "../pages/ContaCorrente/Extrato";
import CompHomo from "../pages/ContaCorrente/CompHomo";
import Compensacoes from "../pages/ContaCorrente/Compensacoes";
import INSS from "../pages/ContaCorrente/INSS";
import PISCOFINS from "../pages/ContaCorrente/PISCOFINS";
import IRPJCSLL from "../pages/ContaCorrente/IRPJCSLL";
import ICMS from "../pages/ContaCorrente/ICMS";
import ISS from "../pages/ContaCorrente/ISS";
import AcaoJudicial from "../pages/ContaCorrente/AcaoJudicial";
import CE from "../pages/ContaCorrente/CE";
import PERDCOMP from "../pages/ContaCorrente/PERDCOMP";
import CategoriasVerbas from "../pages/CategoriasVerbas";
import CadastroDetalhadoCliente from "../components/CadastroDetalhadoCliente";
import FatorConversao from "../pages/FatorConversao";
import TabelaNcm from "../pages/TabelaNcm";
import ContasResultado from "../pages/ContasResultado";
import AtualizarSelic from "../pages/AtualizarSelic";
import Redirect from "../pages/Redirect";
import { PreviaPisCofinsProvider } from "../pages/PreviaPISCOFINS/PreviaPisCofinsContext";
import ContaCorrente from "../pages/ContaCorrente";
import ContaCorrenteDetalhes from "../pages/ContaCorrente/ContaCorrenteDetalhes/index";
import ParceirosAssociados from "../pages/ParceirosAssociados";
import ParceirosAssociadosForm from "../pages/ParceirosAssociados/ParceirosAssociadosForm";

function aplicarTokenRenovado(response) {
  if (response?.token) {
    Token.setToken(response.token);
    api.defaults.headers.Authorization = `${response.token}`;
  }
}

const AuthWrapper = () => {
  const location = useLocation();
  const { handleLogout } = useContext(Context);
  const { dadosLogin, setDadosLogin } = useContext(LoginContext);
  const precisaHidratarSessao =
    Boolean(Token.getToken()) &&
    (dadosLogin?.idUsuario === "" ||
      dadosLogin?.idUsuario === null ||
      dadosLogin?.idUsuario === undefined);
  const [isRestoringSession, setIsRestoringSession] = useState(
    () => precisaHidratarSessao
  );

  useEffect(() => {
    if (dadosLogin?.idUsuario !== "" && dadosLogin?.idUsuario != null) {
      verificarTokenHandler({
        token: Token.getToken(),
        validacaoFront: true,
      })
        .then((response) => {
          if (!response?.sucesso) {
            if (response?.codigoErro === "INACTIVITY_TIMEOUT") {
              alert(`Sua sessão expirou por inatividade (${response?.tempoInatividade || 30} minutos sem ação). Por favor, faça login novamente.`);
            }
            handleLogout();
            return;
          }
          aplicarTokenRenovado(response);
        })
        .catch(() => {
          handleLogout();
        });
      return;
    }
    const token = Token.getToken();
    if (token) {
      setIsRestoringSession(true);
      verificarTokenHandler({ token, validacaoFront: true })
        .then((response) => {
          if (response?.sucesso) {
            aplicarTokenRenovado(response);
            const idUsuario =
              response?.jwtDecodificado?.userId ?? IdUsuario.getUserId();
            setDadosLogin({
              status: "ok",
              email: "",
              tipoCadastroPlanTribKey: "I", // Default "I" para usuários internos na hidratação
              idUsuario: idUsuario != null ? String(idUsuario) : "",
            });
            if (idUsuario) {
              IdUsuario.setUserId(idUsuario);
              connectSocket({ idUsuario });
            }
          } else {
            if (response?.codigoErro === "INACTIVITY_TIMEOUT") {
              alert(`Sua sessão expirou por inatividade (${response?.tempoInatividade || 30} minutos sem ação). Por favor, faça login novamente.`);
            }
            handleLogout(`${location.pathname}${location.search}`);
          }
        })
        .catch(() => {
          handleLogout(`${location.pathname}${location.search}`);
        })
        .finally(() => {
          setIsRestoringSession(false);
        });
      return;
    }
    handleLogout(`${location.pathname}${location.search}`);
  }, [location]);

  if (isRestoringSession) {
    return <Loading loading={true} color="white" />;
  }
  return dadosLogin?.idUsuario !== "" && dadosLogin?.idUsuario != null ? (
    <Outlet />
  ) : (
    <Navigate to="/" replace state={{ from: location }} />
  );
};

const LoginWrapper = () => {
  const location = useLocation();
  const { authenticated } = useContext(Context);

  const navigateTo =
    location.state?.from?.pathname + location.state?.from?.search ||
    "/dashboard";

  return authenticated ? <Navigate to={navigateTo} replace /> : <Outlet />;
};

let navigate;

export const setNavigate = (nav) => {
  navigate = nav;
};

export const getNavigate = () => {
  return navigate;
};

export default function RoutesAdm() {
  const navigate = useNavigate();

  setNavigate(navigate);

  return (
    <Routes>
      <Route element={<LoginWrapper />}>
        <Route index path="/" element={<Login />} />
      </Route>
      <Route element={<AuthWrapper />}>
        <Route element={<Header />}>
          {/* Com autenticação */}
          <Route path="/dashboard" element={<Dashboard />} />
          <Route
            path="/empresas/grupos-economicos"
            element={<Navigate to="/cadastros/grupos-economicos" replace />}
          />
          <Route
            path="/empresas"
            element={<Navigate to="/cadastros/empresas" replace />}
          />
          <Route
            path="/cadastros/empresas/grupos-economicos"
            element={<Navigate to="/cadastros/grupos-economicos" replace />}
          />
          <Route
            path="/cadastros/grupos-economicos"
            element={
              <RotaProtegida anyOf={CHAVES_ROTA_GRUPOS_ECONOMICOS}>
                <GruposEconomicos />
              </RotaProtegida>
            }
          />
          <Route
            path="/cadastros/empresas"
            element={
              <RotaProtegida anyOf={CHAVES_ROTA_EMPRESAS}>
                <Empresas />
              </RotaProtegida>
            }
          />
          <Route
            path="/cadastrar-associado-detalhado"
            element={<CadastroDetalhado />}
          />
          <Route
            path="/cadastrar-parceiro-detalhado"
            element={<CadastroDetalhado />}
          />
          <Route
            path="/cadastrar-cliente-detalhado"
            element={<CadastroDetalhadoCliente />}
          />
          <Route path="/proposta-em-analise" element={<PropostaEmAnalise />} />
          <Route path="/cadastrar-cnpj" element={<CadastrarCnpj />} />
          <Route path="/perfil/meus-dados" element={<DashboardDados />} />
          <Route
            path="/sugestao-de-servicos"
            element={<SugestaoDeServicos />}
          />
          <Route
            path="/selecionar-tipos-negocio"
            element={<SelecionarTiposNegocio />}
          />
          <Route
            path="/selecionar-tipos-negocio-simples"
            element={<SelecionarTiposNegocioSimples />}
          />
          <Route
            path="/juridico/proponentes"
            element={
              <RotaProtegida anyOf={CHAVES_ROTA_JURIDICO}>
                <Juridico />
              </RotaProtegida>
            }
          />
          <Route
            path="/vinculos/gestao-vinculos"
            element={
              <RotaProtegida anyOf={CHAVES_ROTA_VINCULOS}>
                <Vinculos />
              </RotaProtegida>
            }
          />
          <Route path="/acesso-negado" element={<AcessoNegado />} />
          <Route
            path="/acessos/usuarios"
            element={<Navigate to="/cadastros/usuarios" replace />}
          />
          <Route
            path="/cadastros/usuarios"
            element={
              <RotaProtegida anyOf={CHAVES_GERENCIAMENTO_USUARIOS}>
                <Usuarios />
              </RotaProtegida>
            }
          />
          <Route
            path="/acessos/grupos-usuarios"
            element={<Navigate to="/cadastros/grupos-usuarios" replace />}
          />
          <Route
            path="/cadastros/grupos-usuarios"
            element={
              <RotaProtegida anyOf={CHAVES_ROTA_GRUPOS_ACESSO}>
                <GruposUsuarios />
              </RotaProtegida>
            }
          />
          <Route
            path="/editar-dados-candidato"
            element={<EditarDadosCandidato />}
          />
          <Route path="/parametros" element={<Parametros />} />
          <Route
            path="/relatorios/gestao-relatorios"
            element={
              <RotaProtegida anyOf={CHAVES_ROTA_RELATORIOS}>
                <Relatorios />
              </RotaProtegida>
            }
          />
          <Route
            path="/workflow/configurar-fluxos"
            element={
              <RotaProtegida anyOf={CHAVES_ROTA_WORKFLOW}>
                <Workflow />
              </RotaProtegida>
            }
          />
          <Route
            path="/workflow/solicitacoes"
            element={
              <RotaProtegida anyOf={CHAVES_ROTA_WORKFLOW}>
                <Solicitacoes />
              </RotaProtegida>
            }
          />
          <Route
            path="/relatorios/extrator"
            element={
              <RotaProtegida anyOf={CHAVES_ROTA_RELATORIOS}>
                <ExtratorRelatorios />
              </RotaProtegida>
            }
          />
          <Route
            path="/relatorios/apuracoes"
            element={
              <RotaProtegida anyOf={CHAVES_ROTA_APURACOES}>
                <Apuracoes />
              </RotaProtegida>
            }
          />
          <Route
            path="/relatorios/apuracoes/:id/detalhe"
            element={
              <RotaProtegida anyOf={CHAVES_ROTA_APURACOES}>
                <ApuracaoDetalheDispatcher />
              </RotaProtegida>
            }
          />
          <Route
            path="/relatorios/tributarias"
            element={<Navigate to="/parametrizacoes/tributarias" replace />}
          />
          <Route
            path="/relatorios/apuracoes/:id/detalhe/conta"
            element={
              <RotaProtegida anyOf={CHAVES_ROTA_APURACOES}>
                <ApuracaoDetalheConta />
              </RotaProtegida>
            }
          />
          <Route
            path="/relatorios/apuracoes/:id/esocial/lancamentos"
            element={
              <RotaProtegida anyOf={CHAVES_ROTA_APURACOES}>
                <ApuracaoDetalheLancamentosEsocial />
              </RotaProtegida>
            }
          />
          <Route
            path="/relatorios/apuracoes/:id/detalhe/cat42"
            element={
              <RotaProtegida anyOf={CHAVES_ROTA_APURACOES}>
                <ApuracaoDetalheCat42 />
              </RotaProtegida>
            }
          />
          <Route
            path="/relatorios/apuracoes/:id/detalhe/cat42/lancamentos"
            element={
              <RotaProtegida anyOf={CHAVES_ROTA_APURACOES}>
                <LancamentosCat42 />
              </RotaProtegida>
            }
          />
          <Route
            path="/relatorios/apuracoes/:id/detalhe/icms"
            element={
              <RotaProtegida anyOf={CHAVES_ROTA_APURACOES}>
                <ApuracaoDetalheIcms />
              </RotaProtegida>
            }
          />
          <Route
            path="/relatorios/apuracoes/:id/detalhe/icms/lancamentos"
            element={
              <RotaProtegida anyOf={CHAVES_ROTA_APURACOES}>
                <LancamentosIcmsE111 />
              </RotaProtegida>
            }
          />
          <Route
            path="/relatorios/apuracoes/:id/detalhe/icms/lancamentos-notas-fiscais"
            element={
              <RotaProtegida anyOf={CHAVES_ROTA_APURACOES}>
                <LancamentosNotasFiscais />
              </RotaProtegida>
            }
          />
          <Route
            path="/relatorios/apuracoes/:id/detalhe/icms/lancamentos-ecd"
            element={
              <RotaProtegida anyOf={CHAVES_ROTA_APURACOES}>
                <LancamentosEcd />
              </RotaProtegida>
            }
          />
          <Route
            path="/relatorios/apuracoes/:id/detalhe/icms/lancamentos-ecf"
            element={
              <RotaProtegida anyOf={CHAVES_ROTA_APURACOES}>
                <LancamentosEcf />
              </RotaProtegida>
            }
          />
          <Route
            path="/relatorios/apuracoes/:id/detalhe/icms/lancamentos-contribuicoes"
            element={
              <RotaProtegida anyOf={CHAVES_ROTA_APURACOES}>
                <LancamentosContribuicoes />
              </RotaProtegida>
            }
          />
          <Route
            path="/relatorios/apuracoes/:id/detalhe/icms/lancamentos-ecredac"
            element={
              <RotaProtegida anyOf={CHAVES_ROTA_APURACOES}>
                <LancamentosEcredac />
              </RotaProtegida>
            }
          />
          {/* TXM-472 — :id aqui é a apuração ICMS pai; a tela resolve a filha CAT-42 sozinha. */}
          <Route
            path="/relatorios/apuracoes/:id/detalhe/icms/classificacao-ncm"
            element={
              <RotaProtegida anyOf={CHAVES_ROTA_APURACOES}>
                <ClassificacaoNcm />
              </RotaProtegida>
            }
          />
          <Route
            path="/relatorios/processamento"
            element={
              <RotaProtegida anyOf={CHAVES_ROTA_PROCESSAMENTO}>
                <ProcessamentoRelatorio />
              </RotaProtegida>
            }
          />
          <Route
            path="/importacoes/importadores"
            element={
              <RotaProtegida anyOf={CHAVES_ROTA_IMPORTACOES}>
                <Importadores />
              </RotaProtegida>
            }
          />
          <Route
            path="/importacoes/automacoes"
            element={
              <RotaProtegida anyOf={CHAVES_ROTA_AUTOMACOES}>
                <Automacoes />
              </RotaProtegida>
            }
          />
          <Route
            path="/financeiro/condicao-comercial"
            element={
              <RotaProtegida anyOf={CHAVES_ROTA_FINANCEIRO}>
                <CondicaoComercial />
              </RotaProtegida>
            }
          />
          <Route
            path="/financeiro/valores-fatura"
            element={
              <RotaProtegida anyOf={CHAVES_ROTA_FINANCEIRO}>
                <ValoresFatura />
              </RotaProtegida>
            }
          />
          <Route path="/leitor-pdf" element={<PdfUploader />} />
          <Route
            path="/financeiro/faturamento"
            element={
              <RotaProtegida anyOf={CHAVES_ROTA_FINANCEIRO}>
                <Faturamento />
              </RotaProtegida>
            }
          />
          <Route
            path="/aguardando-assinatura"
            element={<AguardandoAssinatura />}
          />
          <Route path="/juridico/assinatura" element={<AssinaturaContrato />} />
          <Route path="/juridico/contratos" element={<Contratos />} />
          <Route
            path="/parametrizacoes/categorias-tributarias"
            element={
              <RotaProtegida anyOf={CHAVES_ROTA_PARAMETRIZACOES}>
                <CategoriasTributarias />
              </RotaProtegida>
            }
          />
          <Route
            path="/parametrizacoes/embazamento-legal"
            element={
              <RotaProtegida anyOf={CHAVES_ROTA_PARAMETRIZACOES}>
                <CategoriasVerbas />
              </RotaProtegida>
            }
          />
          <Route
            path="/parametrizacoes/fator-conversao"
            element={
              <RotaProtegida anyOf={CHAVES_ROTA_PARAMETRIZACOES}>
                <FatorConversao />
              </RotaProtegida>
            }
          />
          <Route
            path="/parametrizacoes/tabela-ncm"
            element={
              <RotaProtegida anyOf={CHAVES_ROTA_PARAMETRIZACOES}>
                <TabelaNcm />
              </RotaProtegida>
            }
          />
          <Route
            path="/parametrizacoes/atualizar-selic"
            element={
              <RotaProtegida anyOf={CHAVES_ROTA_PARAMETRIZACOES}>
                <AtualizarSelic />
              </RotaProtegida>
            }
          />
          <Route
            path="/parametrizacoes/impostos-esocial"
            element={
              <RotaProtegida anyOf={CHAVES_ROTA_PARAMETRIZACOES}>
                <Impostos />
              </RotaProtegida>
            }
          />
          <Route
            path="/parametrizacoes/tributarias"
            element={
              <RotaProtegida anyOf={CHAVES_ROTA_PARAMETRIZACOES}>
                <Tributarias />
              </RotaProtegida>
            }
          />
          <Route
            path="/parametrizacoes/contas-resultado"
            element={
              <RotaProtegida anyOf={CHAVES_ROTA_PARAMETRIZACOES}>
                <ContasResultado />
              </RotaProtegida>
            }
          />
          <Route path="/esocial/ajustes-verbas" element={<AjustesVerbas />} />
          <Route path="/esocial/bases-calculo" element={<BasesCalculo />} />
          <Route path="/esocial/folha-esocial" element={<FolhaESocial />} />
          <Route path="/esocial/folha-manual" element={<FolhaManual />} />
          <Route path="/esocial/impostos" element={<Impostos />} />
          <Route path="/esocial/resumo-geral" element={<ResumoGeral />} />
          <Route path="/esocial/verbas-esocial" element={<VerbasESocial />} />
          <Route path="/esocial/verbas-manuais" element={<VerbasManuais />} />
          <Route
            path="/esocial/previas"
            element={
              <RotaProtegida anyOf={CHAVES_ROTA_INSS}>
                <PreviaINSS />
              </RotaProtegida>
            }
          />
          <Route
            path="/esocial/projetos"
            element={
              <RotaProtegida anyOf={CHAVES_ROTA_INSS}>
                <ProjetosINSS />
              </RotaProtegida>
            }
          />
          <Route
            path="/inss"
            element={
              <RotaProtegida anyOf={CHAVES_ROTA_INSS}>
                <Navigate to="/esocial/previas" replace />
              </RotaProtegida>
            }
          />
          <Route
            path="/inss/processos"
            element={
              <RotaProtegida anyOf={CHAVES_ROTA_INSS}>
                <Navigate to="/esocial/previas" replace />
              </RotaProtegida>
            }
          />
          <Route
            path="/cadastrar-cliente-simples"
            element={<CadastroClienteSimples />}
          />
          <Route
            path="/icms/previas"
            element={
              <RotaProtegida anyOf={CHAVES_ROTA_ICMS}>
                <PreviaICMS />
              </RotaProtegida>
            }
          />
          <Route
            path="/icms/projetos"
            element={
              <RotaProtegida anyOf={CHAVES_ROTA_ICMS}>
                <ProjetosICMS />
              </RotaProtegida>
            }
          />
          <Route
            element={
              <RotaProtegida anyOf={CHAVES_ROTA_PIS_COFINS}>
                <PreviaPisCofinsProvider>
                  <Outlet />
                </PreviaPisCofinsProvider>
              </RotaProtegida>
            }
          >
            <Route path="/piscofins/previas" element={<PreviaPISCOFINS />} />
            <Route
              path="/piscofins/previas/:versaoId/sob-despesas"
              element={<SobDespesas />}
            />
            {/* Rota BaseCredito removida - página não existe mais */}
            {/* <Route
              path="/piscofins/previas/:versaoId/base-credito"
              element={<BaseCredito />}
            /> */}
            <Route
              path="/piscofins/previas/:versaoId/base-legal"
              element={<BaseLegal />}
            />
            <Route
              path="/piscofins/previas/:versaoId/resumo-geral"
              element={<ResumoGeralPisCofins />}
            />
            <Route path="/piscofins/projetos" element={<ProjetosPISCOFINS />} />
          </Route>
          {/* Rotas de Conta Corrente - ordem específica antes de genérica */}
          {/* TXM-558 — Projetos de Apuração: permissão própria (projetos-apuracao-view) */}
          <Route
            path="/conta-corrente/projetos"
            element={
              <RotaProtegida anyOf={CHAVES_ROTA_PROJETOS_APURACAO}>
                <ListaProjetosApuracao />
              </RotaProtegida>
            }
          />
          <Route
            path="/conta-corrente/projetos/:id"
            element={
              <RotaProtegida anyOf={CHAVES_ROTA_PROJETOS_APURACAO}>
                <ResumoProjetoApuracao />
              </RotaProtegida>
            }
          />
          <Route
            path="/conta-corrente/extrato"
            element={
              <RotaProtegida anyOf={CHAVES_ROTA_CONTA_CORRENTE}>
                <ContaCorrente />
              </RotaProtegida>
            }
          />
          <Route
            path="/conta-corrente/extrato/:cnpj"
            element={
              <RotaProtegida anyOf={CHAVES_ROTA_CONTA_CORRENTE}>
                <ContaCorrenteDetalhes />
              </RotaProtegida>
            }
          />
          {/* Parceiros e Associados */}
          <Route
            path="/acessos/parceiros-associados"
            element={
              <RotaProtegida anyOf={CHAVES_ROTA_PARCEIROS}>
                <ParceirosAssociados />
              </RotaProtegida>
            }
          />
          <Route
            path="/acessos/parceiros-associados/novo"
            element={
              <RotaProtegida anyOf={CHAVES_ROTA_PARCEIROS}>
                <ParceirosAssociadosForm />
              </RotaProtegida>
            }
          />
          <Route
            path="/acessos/parceiros-associados/:id"
            element={
              <RotaProtegida anyOf={CHAVES_ROTA_PARCEIROS}>
                <ParceirosAssociadosForm />
              </RotaProtegida>
            }
          />
        </Route>
      </Route>

      <Route>
        {/* Sem autenticação */}
        <Route path="/redefinir-senha" element={<EditPassword />} />
        <Route path="/esqueci-minha-senha" element={<ForgotPassword />} />
        <Route path="/vamos-vencer-juntos" element={<VamosVencerJuntos />} />
        <Route
          path="/validar-codigo-email"
          element={<ValidacaoCodigoEmail />}
        />
        <Route path="/cadastrar-associado" element={<CadastroAssociado />} />
        <Route path="/cadastrar-parceiro" element={<CadastroParceiro />} />
        <Route path="/cadastrar-cliente" element={<CadastroCliente />} />
        <Route path="/relatorios/redirect" element={<Redirect />} />
      </Route>
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}
